module.exports = __webpack_public_path__ + "assets/img/18_1854_big.417a0670.jpg";